module.exports = __webpack_public_path__ + "media/application/images/ui/icon-email-55f94ec7b89d9b5c59274b206fca4c6f.png";